export class VelatirError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VelatirError';
  }
}

export class VelatirAPIError extends VelatirError {
  public readonly code?: string | number;
  public readonly httpStatus?: number;
  public readonly httpBody?: string;

  constructor(
    message: string,
    code?: string | number,
    httpStatus?: number,
    httpBody?: string
  ) {
    super(message);
    this.name = 'VelatirAPIError';
    this.code = code;
    this.httpStatus = httpStatus;
    this.httpBody = httpBody;
  }
}

export class VelatirTimeoutError extends VelatirError {
  constructor(message: string) {
    super(message);
    this.name = 'VelatirTimeoutError';
  }
}

export class VelatirWatchDeniedError extends VelatirError {
  public readonly requestId: string;

  constructor(requestId: string) {
    const message = `Function execution denied by Velatir (request_id: ${requestId})`;
    super(message);
    this.name = 'VelatirWatchDeniedError';
    this.requestId = requestId;
  }
}